module.exports = __webpack_public_path__ + "static/iso-d59fec4aa647ec5119b601e78c786d8a.svg";